module.exports = __webpack_public_path__ + "img/plate02_07.1f87437c.png";